<template>
  <v-container>
    <v-dialog v-model="dialog_value.show" max-width="700px"
              @click:outside="$store.commit('close_delete_attachment_admin_dialog')">
      <v-card>

        <v-card-text class="mt-5 pb-0">
          <v-row>
            <v-col v-if="dialog_value.show" >
              <h2 class="pt-4">
              آیا از حذف {{ get_attachment_type_text(dialog_value.attachment.type) }}
                اطمینان دارید؟
              </h2>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="$store.commit('close_delete_attachment_admin_dialog')">
            خیر
          </v-btn>
          <v-btn color="error" @click="$store.dispatch('delete_attachment_admin',{id:dialog_value.attachment.id})">
            بله
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>

</template>

<script>
import {mapState} from "vuex";
import Statics from "@/components/common/Statics";

export default {
  name: "DeleteAttachmentAdmin",
  computed: {
    ...mapState({
      dialog_value: state => state.Admin.settings.delete_attachment_dialog
    }),
  },
  data(){
    return{
      attachment_types: Statics.attachments
    }
  },
  methods:{
        get_attachment_type_text(obj){
      let text = ""
      this.attachment_types.forEach((element) => {
        if (element.type == obj) {
          text = element.title
        }
      })
      return text
    },

  }
}
</script>

<style scoped>

</style>